import { render, staticRenderFns } from "./chatRoom.vue?vue&type=template&id=0329247d&scoped=true"
import script from "./chatRoom.vue?vue&type=script&lang=js"
export * from "./chatRoom.vue?vue&type=script&lang=js"
import style0 from "./chatRoom.vue?vue&type=style&index=0&id=0329247d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0329247d",
  null
  
)

export default component.exports